import CantileverButton from 'components/CantileverButton'
import React from 'react'
import styled from 'styled-components'

const BannerContainer = styled.div<{ $backgroundColor?: string }>`
  display: flex;
  width: 100%;
  height: 3rem;
  background-color: ${({ $backgroundColor, theme }) =>
    $backgroundColor
      ? $backgroundColor
      : `color-mix(in srgb, ${theme.forecast.warning} 20%, transparent 80%)`};
  border-radius: 0.5rem;
  border-bottom: 0.063rem solid rgba(0, 0, 0, 0.25);
  justify-content: space-between;
`

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  overflow-y: auto;
  overflow-x: hidden;
`

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
`

const BannerTextContainer = styled.div`
  padding-left: 1rem;
  align-self: center;
`

const BannerButtonContainer = styled.div`
  display: flex;
  align-content: center;
  padding: 0.5rem;
  gap: 1rem;
`
const StyledPrimaryText = styled.p`
  size: 0.875;
  line-height: 1.25;
  color: ${({ theme }) => theme.forecast.defaultText};
`

const StyledSecondaryText = styled.p`
  size: 0.75rem;
  line-height: 1rem;
  color: ${({ theme }) => theme.forecast.secondaryText};
`

const ResolveButton = styled(CantileverButton)`
  padding: 0rem 1.5rem;
`

interface CantileverCallToActionBannerProps {
  onClick?: () => void
  primaryText: string
  secondaryText: string
  buttonText?: string
  secordaryOnClick?: () => void
  secondaryButtonText?: string
  $backgroundColor?: string
}

export const CantileverCallToActionBanner: React.FC<
  CantileverCallToActionBannerProps
> = ({
  onClick,
  primaryText,
  secondaryText,
  buttonText,
  secordaryOnClick,
  secondaryButtonText,
  $backgroundColor,
}) => {
  return (
    <InfoContainer>
      <DetailsContainer>
        <BannerContainer $backgroundColor={$backgroundColor}>
          <BannerTextContainer>
            <StyledPrimaryText>{primaryText}</StyledPrimaryText>
            <StyledSecondaryText>{secondaryText}</StyledSecondaryText>
          </BannerTextContainer>
          {buttonText && onClick && (
            <BannerButtonContainer>
              <ResolveButton
                onClick={() => onClick()}
                disabled={false}
                warning={$backgroundColor ? false : true}>
                {buttonText}
              </ResolveButton>
              {secordaryOnClick && secondaryButtonText && (
                <ResolveButton
                  warning
                  onClick={() => secordaryOnClick()}
                  disabled={false}>
                  {secondaryButtonText}
                </ResolveButton>
              )}
            </BannerButtonContainer>
          )}
        </BannerContainer>
      </DetailsContainer>
    </InfoContainer>
  )
}
